// extracted by mini-css-extract-plugin
export var chevron = "_k3-3";
export var chevronRotated = "_k3-4";
export var image = "_k3-1";
export var imageContainer = "_k3-0";
export var shippingAddress = "_k3-2";